import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export default function ProtectedAdminRoute({ children }) {
  const token = localStorage.getItem("membreToken");

  if (!token) {
    return <Navigate to="/" replace />;
  }

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    if (decoded.exp < currentTime) {
      localStorage.removeItem("membreToken");
      localStorage.removeItem("membre");
      return <Navigate to="/" replace />;
    }

    if (decoded.role !== "admin") {
      return <Navigate to="/" replace />;
    }

    return children;

  } catch {
    localStorage.removeItem("membreToken");
    localStorage.removeItem("membre");
    return <Navigate to="/" replace />;
  }
}
